// minimum and maximum star sizes
export const STAR_MIN = 1.0;
export const STAR_MAX = 20.0;

export const HAZE_MAX = 50.0;
export const HAZE_MIN = 20.0;
export const HAZE_OPACITY = 0.2;

export const BASE_LAYER = 1;
export const BLOOM_LAYER = 0;
export const OVERLAY_LAYER = 1;

export const BLOOM_PARAMS = {
  exposure: 1,
  bloomStrength: 1.5,
  bloomThreshold: 0.4,
  bloomRadius: 0,
};
